import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import classnames from "classnames";
import { RadioControl } from "./RadioControl";
import styles from "./RadioButton.module.scss";
export const RadioButton = forwardRef(({ label, className, error, ...rest }, ref) => {
    return (_jsxs("label", { className: classnames(styles.radioLabel, className, {
            [styles.disabled]: rest.disabled,
            [styles.error]: error,
        }), children: [_jsx(RadioControl, { ref: ref, ...rest }), typeof label === "string" ? _jsx("span", { className: styles.labelText, children: label }) : label] }));
});
RadioButton.displayName = "RadioButton";
//# sourceMappingURL=RadioButton.js.map